export const subDataBg = [
    'rgba(34,211,238,0.2)',
                'rgba(239,68,68,0.2)',
                'rgba(74,222,128,0.2)',
                'rgba(94,234,212,0.2)',
                'rgba(249,115,22,0.2)',
                'rgba(251,191,36,0.2)',
                'rgba(34,211,238,0.2)',
                'rgba(163,230,53,0.2)',
                'rgba(124,58,237,0.2)',
                'rgba(217,70,239,0.2)',
                'rgba(236,72,153,0.2)',
                'rgba(244,63,94,0.2)'
]